import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { itemContext } from "../context/ItemContext";
import ProductItem from "./ProductItem";

const SearchResults = () => {
  const { products } = useContext(itemContext);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("query");

  useEffect(() => {
    if (query) {
      const results = products.filter((product) =>
        product.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredProducts(results);
    }
  }, [query, products]);

  if (filteredProducts.length === 0) {
    return <div>No products found for '{query}'</div>;
  }

  return (
    <div className="product-list">
      <h2>Search Results for '{query}'</h2>
      <ul className="item-card">
        {filteredProducts.map((product) => (
          <ProductItem key={product._id} product={product} />
        ))}
      </ul>
    </div>
  );
};

export default SearchResults;
